import React, { useState, useEffect } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { BorderGradient, SmallLoader } from 'processhub-components-lib';
import { FiCheck, FiX } from 'react-icons/fi';
import { SlArrowRight } from 'react-icons/sl';
import { RemoveItemBtn } from 'components/shared/buttons/RemoveItemBtn';
import OrganizationForm from './Form/OrganizationForm';
import Stepper from './Form/Stepper';
import { AddNewItemBtn } from 'components/shared/buttons/AddNewItemBtn';

interface OrganizationWizardProps {
    isOrganizationWizardOpen: boolean;
    mode: string;
    orgFormState: any;
    isLoading: boolean;
    orgStep: number;
    setOrgStep: React.Dispatch<React.SetStateAction<number>>;
    setRefreshMode: (refreshMode: string) => void;
    setError: (error: string) => void;
    setOrgFormState: React.Dispatch<React.SetStateAction<any>>;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
    handleOrganizationWizardClose: () => void;
}

const steps = [
    { number: 1, label: "Fill Details" },
    { number: 2, label: "Confirm Details" },
];


const OrganizationWizard: React.FC<OrganizationWizardProps> = ({orgStep, setOrgStep, mode, isOrganizationWizardOpen, setRefreshMode, setError, orgFormState, setOrgFormState, setIsLoading, handleOrganizationWizardClose, isLoading }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [submitOrganizationForm, setSubmitOrganizationForm] = useState<(() => void) | null>(null);

    // Reset step to 1 when wizard is opened
    useEffect(() => {
        if (isOrganizationWizardOpen) {
            setOrgStep(1);
        }
    }, [isOrganizationWizardOpen, setOrgStep]);

    const goNext = () => {
        setOrgStep(orgStep + 1);
    };

    const goBack = () => {
        setOrgStep(orgStep - 1);
    };

        const handleStepChange = (stepCircle: number) => {
        if (stepCircle === 2 && orgStep === 1) {
            if (!orgFormState.name || !orgFormState.desc) return;
        }
       

        setOrgStep(stepCircle);
    };

    const handleSubmitFromStep2 = () => {
        if (submitOrganizationForm) {
            submitOrganizationForm();
        }
    };

    const handleSaveSubmitFunction = (submitFn: () => void) => {
        setSubmitOrganizationForm(() => submitFn);
    };

    const openModal = () => setIsModalOpen(true);

    return (
        <div>
            <Dialog.Root open={isOrganizationWizardOpen} onOpenChange={handleOrganizationWizardClose}>
                <Dialog.Portal>
                    <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
                    <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] lg:w-[1024px] h-[60vh]">
                        <BorderGradient className='rounded-lg flex flex-col h-full w-full'>
                            <div className="bg-[#1A1A1A] rounded-lg p-6 relative text-white overflow-y-auto flex flex-col h-full ">
                                {/* Close Button */}
                                <button
                                    onClick={handleOrganizationWizardClose}
                                    className="absolute top-[28px] right-4 text-gray-400 hover:text-white"
                                >
                                    <FiX size={24} />
                                </button>

                                {/* Navigation */}
                                {mode === "create" ? (
                                    <div className="flex justify-center gap-10  items-center mb-5   w-full">

                                        {orgStep !== 1 ? (
                                            <button
                                                onClick={goBack}
                                                disabled={orgStep === 1}
                                                className={`flex flex-row items-center gap-2 bg-[#2A2A2A] hover:bg-[#3a3a3a33] rounded-md rotate-180 p-3 py-2 text-center text-sm 2xl:text-md font-bold 
                                                    bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90 text-white ${orgStep === 1 ? 'bg-gray-700 cursor-not-allowed' : 'bg-gray-600 hover:bg-gray-500 mb-[25px]'
                                                    }`}
                                            >
                                                <SlArrowRight />
                                            </button>
                                        ) : (
                                            <div className="w-[44px]" />
                                        )}

                                        <div className=" justify-center">
                                            <Stepper steps={steps} handleStepChange={handleStepChange} currentStep={orgStep} />
                                        </div>

                                        <div className="flex justify-end">
                                            {orgStep === 1 && (
                                                <>
                                                    <button
                                                        onClick={goNext}
                                                        className={`flex flex-row items-center gap-2 rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold mb-[25px] ${
                                                            orgFormState.name && orgFormState.desc
                                                                ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90'
                                                                : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'
                                                        }`}
                                                        disabled={!orgFormState.name || !orgFormState.desc}
                                                    >
                                                        <SlArrowRight />
                                                    </button>
                                                </>
                                            )}

                                            {orgStep === 2 && (
                                                <AddNewItemBtn
                                                    onClick={handleSubmitFromStep2}
                                                    className='mb-[25px] bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90' btnType="filled" type="submit" isDisabled={false}>
                                                    {isLoading ? (
                          <SmallLoader />
                        ) : (
                          <div className="flex items-center">
                            <FiCheck className="mr-2" />
                            <span> Create</span>
                          </div>
                        )}
                                                    {/* {mode === 'edit' && <span>Edit Organization</span>} */}
                                                </AddNewItemBtn>
                                            )}

                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex justify-end items-center mt-5">
                                        <div className="flex gap-2 items-center">
                                            <RemoveItemBtn  onClick={openModal} isDisabled={false} type="button">
                                                Remove Organization
                                            </RemoveItemBtn>
                                            <AddNewItemBtn
                                                onClick={handleSubmitFromStep2}
                                                 btnType="filled" type="submit" isDisabled={false}>
                                                <span>Edit Organization</span>
                                            </AddNewItemBtn>

                                        </div>
                                    </div>
                                )}

                                {mode === "create" && orgStep === 1 && (
                                    <div>
                                        <OrganizationForm  setOrgStep={setOrgStep} setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen} setRefreshMode={setRefreshMode} setError={setError} mode="create" formState={orgFormState} setFormState={setOrgFormState} setIsLoading={setIsLoading} handleOrganizationWizardClose={handleOrganizationWizardClose} onSaveSubmitFunction={handleSaveSubmitFunction} />
                                    </div>
                                )}

                                {mode === "create" && orgStep === 2 && (
                                    <>
                                     <div className="h-full">
                                     <h2 className="text-2xl font-semibold mb-6">Confirm Organization Details</h2>
                                     <div className="bg-[#2A2A2A]/50 rounded-lg p-6 space-y-6">
                                     <div className="space-y-4">
                            <div>
                              <label className="block text-sm text-gray-400 mb-1">Organization Name</label>
                              <p className="text-white font-medium">{orgFormState.name}</p>
                            </div>
                            <div>
                              <label className="block text-sm text-gray-400 mb-1">Description</label>
                              <p className="text-white font-medium">{orgFormState.desc}</p>
                            </div>
                            </div>
                                     </div>
                                     </div>
                                        </>
                                )}

                                {mode === "edit" && (
                                    <div>
                                        <h2 className="text-base font-semibold mb-8">EDIT ORGANIZATION</h2>
                                        <OrganizationForm setOrgStep={setOrgStep} setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen} handleOrganizationWizardClose={handleOrganizationWizardClose} setRefreshMode={setRefreshMode} setError={setError} mode="edit" formState={orgFormState} setFormState={setOrgFormState} setIsLoading={setIsLoading} onSaveSubmitFunction={handleSaveSubmitFunction} />
                                    </div>
                                )}

                            </div>
                        </BorderGradient>
                    </Dialog.Content>
                </Dialog.Portal>
            </Dialog.Root>
        </div>
    );
};

export default OrganizationWizard;
